
import { CreateElement, VNode } from 'vue'
import { Component, mixins } from '@niknevis/vue-modules'
import { InjectReactive, Prop } from 'vue-property-decorator'
import { RenderTd } from '@/modules/common/tes-table/components/shared/base/RenderTd'

@Component
export default class TesTd extends mixins<RenderTd>(RenderTd) {
  @Prop() props!: any

  @Prop() hideTitle!: boolean

  @InjectReactive()
  grid!: any

  render(h: CreateElement): VNode {
    return this.__renderTd(
      h,
      this.props.col,
      this.grid,
      this.$scopedSlots.default && this.$scopedSlots.default({}),
      this.hideTitle
    )
  }
}
